import React from "react";
import { Form, Card } from "react-bootstrap";

function Category({ categories, categoriesSelected, setCategoriesSelected }) {
  const handleSelect = (event) => {
    if (categoriesSelected.indexOf(event.target.value) !== -1) {
      let tempSelectedCategories = [...categoriesSelected];
      let index = tempSelectedCategories.indexOf(event.target.value);
      tempSelectedCategories.splice(index, 1);
      setCategoriesSelected(tempSelectedCategories);
    } else {
      let tempSelectedCategories = [...categoriesSelected];
      tempSelectedCategories.push(event.target.value);
      setCategoriesSelected(tempSelectedCategories);
    }
  };

  return (
    <div>
      <Card>
        <Card.Header>
          <span className="d-flex aling-items-center pt-2 pb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="rgb(151 98 98)"
              stroke="rgb(119, 33, 33)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            <span className="ps-1 " style={{ fontFamily: "'Lobster Two', cursive" }}>
              {" "}
              Filtrar
            </span>
          </span>
        </Card.Header>

        <Card.Body className="pt-1">
          <div
            className="mt-0 pt-0 mb-1 d-flex align-items-center"
            style={{ fontFamily: "'Lobster Two', cursive" }}
          >
            <img
              src="https://www.svgrepo.com/show/219056/grape.svg"
              intrinsicsize="512 x 512"
              width="20"
              height="20"
              srcSet="https://www.svgrepo.com/show/219056/grape.svg 4x"
              alt="Grape SVG Vector"
              title="Grape SVG Vector"
            />
            {"  "}
            <span className="ps-2 fs-4">Categorías:</span>
          </div>
          <hr className="mt-0 mb-1" />

          <div>
            {categories.map((category) => (
              <Form.Check
                type={"checkbox"}
                key={category._id}
                id={category._id}
                label={category.name}
                value={category._id}
                onChange={handleSelect}
                className="fs-5"
                style={{
                  fontFamily: "'Lobster Two', cursive",
                }}
              />
            ))}
          </div>
        </Card.Body>
      </Card>
      {/* <Form.Select aria-label="Default select example">
        <option>Seleccionar...</option>
        {categories.map((category) => (
          <option key={category._id} value={category._id} onChange={handleSelect}>
            {category.name}
          </option>
        ))}
      </Form.Select> */}
    </div>
  );
}

export default Category;
